import { local, session } from './storage';
import * as cookie from './cookie';
import { isStorage, getType } from './bll';

/**
 * 缓存读写封装，自适应存储环境
 * 部分环境不支持 mode 1.storage,2.cookie
 * new Cache()
 */
class Cache {
  /** 配置属性 */
  opts = {
    /** 当前存储环境 */
    mode: isStorage ? 1 : 2,
    /** 前缀 */
    pre: '$quickCache',
    /** 应用key */
    key: '',
    /** 后缀命名 pre_key_name */
    name: '',
    /** 自定义缓存全名 */
    full: null
  };

  /**
   * new Cache(_opts) 构造
   * @param {json} _opts 初始化配置 {mode:1_标准,2_cookie,key:应用的key,name:存储的主键名}
   */
  constructor(_opts) {
    /** 当前默认参数 */
    this.setOpts(_opts);
  }

  /**
   * 当前缓存的参数
   */
  getOpts() {
    return this.opts;
  }

  /**
   * 更新缓存参数
   * @param {*} _opts
   */
  setOpts(_opts) {
    for (let k in _opts) {
      this.opts[k] = _opts[k];
    }
    // this.opts.key = this.opts.key || '';
    // this.opts.name = this.opts.name || '';
    // 生成全名组合
    let _fullName = this.opts.pre + '_' + this.opts.key + '_' + this.opts.name;
    this.opts.full = _opts.full || _fullName;
  }

  /**
   * 是否存在缓存名
   * @param {*} key 键名
   * @returns
   */
  isKey(key) {
    if (this.opts.mode === 1) {
      return local.isKey(key);
    } else {
      return cookie.isKey(key);
    }
  }

  /**
   * 取出所有缓存key
   */
  getCacheKeys() {
    if (this.opts.mode === 1) {
      return local.keys();
    } else {
      return cookie.keys();
    }
  }

  /**
   * 取出所有内容
   * @returns json格式
   */
  getCacheAll() {
    if (this.opts.mode === 1) {
      return local.all();
    } else {
      return cookie.all();
    }
  }

  /**
   * 缓存格式写入
   * @param {object} data 写入内容
   * @param {object} type 存储类型，为空默认getType判断
   * 存储的格式化{data:'存储的内容',type:'存储内容的类型',ts:存储的写入时间戳}
   */
  setCache(data, type) {
    if (!data) return;
    // console.log(data)
    // 格式化为string
    let _data = JSON.stringify({
      // 存储的内容
      data,
      // 数据的类型
      type: type || getType(data),
      // 存储的时间戳
      ts: new Date().getTime()
    });

    if (this.opts.mode === 1) {
      return local.setItem(this.opts.full, _data);
    } else {
      return cookie.setItem(this.opts.full, _data);
    }
  }

  /**
   * 取出存储内容
   * @param {boolean} isAll true取出完整缓存内容，反之取出存储data
   */
  getCache(isAll) {
    let jsonStr;
    try {
      if (this.opts.mode === 1) {
        jsonStr = local.getItem(this.opts.full);
      } else {
        jsonStr = cookie.getItem(this.opts.full);
      }
      // console.log(
      //   this.opts.mode + '.getCache:' + this.opts.full,
      //   typeof jsonStr,
      //   jsonStr
      // );

      if (typeof jsonStr == 'string') {
        jsonStr = JSON.parse(jsonStr);
        if (!isAll) {
          // 只取出数据内容
          jsonStr = jsonStr.data;
        }
      }
    } catch (e) {
      // throw e;
      console.error(e);
      // TODO 超出localstorage容量限制则存到plus.storage中
      // 且删除localStorage重复的数据
    }
    // finally {
    // }
    return jsonStr;
  }

  /**
   * 删除指定内容
   * @param {*} key 自定义key,为空默认opts.full
   */
  removeCache(key) {
    key = key || this.opts.full;
    if (this.opts.mode === 1) {
      return local.removeItem(key);
    } else {
      return cookie.removeItem(key);
    }
  }

  /**
   * 删除当前会话
   * @param {*} key 自定义key,为空默认opts.full
   */
  removeSession(key) {
    key = key || this.opts.full;
    if (this.opts.mode === 1) {
      return session.removeItem(key);
    } else {
      return cookie.removeItem(key);
    }
  }

  /**
   * 写入当前会话
   * @param {object} data 写入内容
   * @param {object} type 存储类型，默认为空
   * 存储的格式化{key,{data:'实际存储的内容',t:存储的时间戳}}
   */
  setSession(data, type) {
    if (!data) return;

    let _data = JSON.stringify({
      data,
      // 存储的类型
      type: type || typeof data,
      // 存储的时间戳
      ts: new Date().getTime()
    });

    if (this.opts.mode === 1) {
      return session.setItem(this.opts.full, _data);
    } else {
      return cookie.setItem(this.opts.full, _data);
    }
  }

  /**
   * 取出当前会话
   * @param {boolean} all 只取出实际内容,或取出存储格式全部
   */
  getSession(all) {
    let jsonStr;
    try {
      if (this.opts.mode === 1) {
        jsonStr = session.getItem(this.opts.full);
      } else {
        jsonStr = cookie.getItem(this.opts.full);
      }
      // console.log(jsonStr)
      if (jsonStr) {
        jsonStr = JSON.parse(jsonStr);
        if (!all) {
          // 只取出数据内容
          jsonStr = jsonStr.data;
        }
      }
    } catch (e) {
      // throw e;
      console.error(e);
      // TODO 超出localstorage容量限制则存到plus.storage中
      // 且删除localStorage重复的数据
    }
    // finally {
    // }
    return jsonStr;
  }
}

export default Cache;
